<template>
	<div class="networkroomdetail">
		
		<headerview :cur="4"></headerview>
		<div class="content">
			
			<div class="moddlecon w13 min-h">
				<div class="tipcon">
					<tipconNav :title="'网络课堂'" :name="[{label:'网络课堂',url:'/networkroom'},{label:'详情',url:'/networkroomdetail?id='+$route.query.id}]" :imgtype="'2'" width="2.05"></tipconNav>
				</div>
				
				<div class="list_a">
					<div class="l_c">
						<video :src="$imgUrl + informData.videoUrl_dictText" controls="controls"></video>
					</div>
					<div class="r_c">
						<div class="title">{{informData.title || ''}}</div>
						<div class="sourcetime">
							<span v-if='informData.source'>来源：{{informData.source}}</span>
							<span>发布时间：{{informData.createTime || ''}}</span>
						</div>
						<!-- <div class="shareto">
							分享至:
							<img class="imgwx" src="../../../static/img/wechat@2x.png" alt="" @click="wxshare"/>
							<img class="imgqq" src="../../../static/img/qq@2x.png" alt="" @click="qqshare"/>
						</div> -->
					</div>
				</div>
				
				<div class="list_b">
					<div class="title">课程详情</div>
					<div class="inform">
						<div v-html="regImg(informData.introduction)"></div>
					</div>
				</div>
				
			</div>
				
		</div>
				
		<footview></footview>
				
	</div>
	
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
		id:"",
		informData:{},
	  
    };
  },
  
  mounted() {
	    this.$onScrollT()
		
		if(this.$route.query) {
			this.id = this.$route.query.id;
		}
		this.getYouthteamDetail()
  },

  methods: {
		//少年队网络视频
		getYouthteamDetail(){
			  var self = this;
			  this.$get(`web/teaching/queryById?id=${this.id}`).then(res=>{
				  if(res.success){
						console.log(res)	
						self.informData = res.result	
				  }
			  })		  
		},
		
		regImg(newContent){//富文本图片处理
			if(newContent){
				newContent = newContent.replace(/\<img/gi,'<img style="max-width:100%; width:100%;height:auto;display:block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi,'<video style="max-width:100%; width:100%;height:auto;display:block;margin:10rpx auto;"');
				if(newContent.indexOf('<table')!=-1){
					newContent.replace(/\<table/gi,'<table borer="1"')
				} 
			}
			
			return newContent;
		},
		
		wxshare(){	
			
		},
		
		qqshare(){
			window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(document.location.href));
		}
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.networkroomdetail{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			
			.list_a{
				margin-top: 40px;	
				display: flex;
				justify-content: space-between;
				.l_c{
					width: 780px;
					video{
						width: 780px;
						height: 410px;
					}
				}
				.r_c{
					flex: 1;
					margin-left: 40px;
					.title{
						font-size: 28px;
						font-weight: 400;
						color: #333333;
					}
					.sourcetime{
						margin-top: 20px;
						min-height: 280px;
						font-size: 16px;
						font-weight: 400;
						color: #666666;
						display: flex;
						justify-content: space-between;
					}
					.shareto{
						height: 50px;
						display: flex;
						align-items: center;
						justify-content: flex-start;
						.imgwx,.imgqq{ 
							cursor: pointer;
							margin-left: 20px;
							height: 22px;
						}
						.imgwx{
							width: 26px;
						}
						.imgqq{
							width: 18px;
						}
					}
				}
			}
			
			.list_b{
				margin: 40px 0px 40px 0px;
				padding: 20px 40px 20px 40px;
				min-height: 480px;
				background: #F4F5F8;
				.title{
					font-size: 18px;
					font-weight: bold;
					color: #333333;
					text-align: center;
					margin-bottom: 40px;
				}
				.inform{
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
			}
				
			
		}	
	
	}
	
	
	
}

</style>
<style scoped>
/deep/ .inform img{
	max-width: 100%;
	vertical-align: middle
}
</style>